{
  "mark": "ذكاء اصطناعي",
  "markLabel": "بمساعدة الذكاء الاصطناعي",
  "ask": "اسأل المساعد",
  "drawer": {
    "documents": {
      "attach": "إرفاق صور أو ملفات PDF",
      "remove": "إزالة {{name}}",
      "chosen": "الملفات المراد إرسالها",
      "sent": "الملفات المرسلة",
      "read": "ما قُرئ منها",
      "nothingRead": "تعذّرت قراءة أي شيء منها.",
      "readThem": "ما هذه المستندات؟",
      "refused": {
        "type": "لا يُقرأ إلا الصور (JPG وPNG وWebP) وملفات PDF.",
        "empty": "هذا الملف فارغ.",
        "size": "حجمه أكبر من {{limit}} حتى بعد تصغيره. صوّره صفحةً صفحة، أو احفظ ملف PDF أصغر.",
        "count": "لا يُرسل مع السؤال الواحد أكثر من {{n}} ملفات."
      }
    },
    "title": "المساعد الذكي للمشروع",
    "titleExplain": "شرح هذا التنبيه",
    "disclaimer": "يستخدم بيانات هذا المشروع التي يحق لك الاطلاع عليها، وتُرسل إلى OpenAI بمفتاح شركتك. تحقّق من الأرقام قبل الاستناد إليها. لا يتغيّر شيء حتى تؤكّد.",
    "you": "أنت",
    "assistant": "المساعد الذكي",
    "conversation": "المحادثة",
    "empty": "اسأل عن هذا المشروع: لماذا هو معرّض للخطر، وما الذي يمكن فوترته، وما الذي تغيّر هذا الأسبوع.",
    "suggestions": "اقتراحات",
    "suggest": {
      "risk": "لماذا هذا المشروع معرّض للخطر؟",
      "bill": "ما الذي يمكنني فوترته هذا الشهر؟",
      "week": "ما الذي تغيّر هذا الأسبوع؟"
    },
    "composer": "سؤالك",
    "placeholder": "اكتب سؤالك…",
    "send": "إرسال",
    "stop": "إيقاف",
    "counter": "{{n}} / {{max}}",
    "tooLong": "اختصر سؤالك إلى {{max}} حرف.",
    "delete": "حذف المحادثة",
    "deleteTitle": "حذف هذه المحادثة؟",
    "deleteBody": "تُحذف أسئلتها وإجاباتها الآن. ويحتفظ المسؤول بسجل للتشغيلات دون نصوصها.",
    "deleted": "حُذفت المحادثة",
    "loading": "جارٍ فتح المحادثة…",
    "loadFailed": "تعذّر فتح المحادثة.",
    "purged": "حُذف نص الرسائل السابقة وفق قاعدة الاحتفاظ بالبيانات في شركتك.",
    "working": "جارٍ العمل…",
    "stopped": "أُوقف. لم يتغيّر شيء.",
    "retry": "حاول مرة أخرى",
    "runsLeft_zero": "لم يبقَ لك أي سؤال اليوم",
    "runsLeft_one": "بقي لك سؤال واحد اليوم",
    "runsLeft_two": "بقي لك سؤالان اليوم",
    "runsLeft_few": "بقيت لك {{n}} أسئلة اليوم",
    "runsLeft_many": "بقي لك {{n}} سؤالًا اليوم",
    "runsLeft_other": "بقي لك {{n}} سؤال اليوم",
    "paused_zero": "أكّد المقترح أو ارفضه للمتابعة.",
    "paused_one": "أكّد المقترح أو ارفضه للمتابعة.",
    "paused_two": "أكّد كل مقترح أو ارفضه للمتابعة.",
    "paused_few": "أكّد كل مقترح أو ارفضه للمتابعة.",
    "paused_many": "أكّد كل مقترح أو ارفضه للمتابعة.",
    "paused_other": "أكّد كل مقترح أو ارفضه للمتابعة.",
    "cancelProposals": "إلغاء المقترحات",
    "cancelled": "أُلغيت المقترحات. لم يتغيّر شيء.",
    "noneLeft": "لم يبقَ لك أي سؤال اليوم",
    "proposes": "يقترح المساعد: {{list}}",
    "unanswered": "لم يحصل هذا السؤال على إجابة: أُوقف أو لم يكتمل. اسأل مرة أخرى إن كنت لا تزال تحتاج إليه.",
    "unansweredBy": {
      "cancelled": "لم يحصل هذا السؤال على إجابة: أُوقف. اسأل مرة أخرى إن كنت لا تزال تحتاج إليه.",
      "superseded": "لم يحصل هذا السؤال على إجابة: طُرح سؤال جديد قبل البتّ في مقترحاته، فاستُبعدت.",
      "failed": "لم يحصل هذا السؤال على إجابة. {{reason}}",
      "expired": "لم يحصل هذا السؤال على إجابة: انتهت صلاحية مقترحاته قبل البتّ فيها. اسأل مرة أخرى إن كنت لا تزال تحتاج إليه.",
      "paused": "ينتظر هذا السؤال قرارًا بشأن مقترحاته.",
      "running": "لا تزال الإجابة عن هذا السؤال جارية في علامة تبويب أو نافذة أخرى."
    },
    "earlier": "شروح سابقة"
  },
  "reading": {
    "kinds": {
      "INVOICE": "فاتورة",
      "CREDIT_NOTE": "إشعار دائن",
      "QUOTATION": "عرض سعر",
      "ORDER": "طلب",
      "DELIVERY_NOTE": "مذكرة تسليم",
      "RECEIPT": "إيصال",
      "STATEMENT": "كشف حساب",
      "PRICE_LIST": "قائمة أسعار",
      "OTHER": "مستند",
      "UNKNOWN": "مستند"
    },
    "total": "الإجمالي {{total}}",
    "lines": "البنود: {{n}}"
  },
  "tools": {
    "read_documents": "المستندات التي أرسلتها",
    "propose_record_receipt": "تسجيل مقبوض",
    "propose_pay_supplier": "دفع لمورّد",
    "propose_post_purchase": "ترحيل شراء",
    "propose_void_purchase": "إلغاء شراء",
    "propose_post_credit_note": "ترحيل إشعار دائن",
    "propose_void_credit_note": "إلغاء إشعار دائن",
    "propose_archive_customer": "أرشفة عميل",
    "propose_archive_supplier": "أرشفة مورّد",
    "propose_archive_product": "أرشفة منتج",
    "propose_post_invoice": "ترحيل فاتورة",
    "propose_void_invoice": "إلغاء فاتورة",
    "propose_create_supplier": "موردًا جديدًا",
    "propose_update_supplier": "تعديلًا على مورد",
    "propose_update_prices": "تغيير أسعار",
    "propose_adjust_stock": "تسوية مخزون",
    "propose_draft_invoice": "مسودة فاتورة",
    "propose_draft_quotation": "عرض سعر",
    "propose_draft_purchase_bill": "مسودة فاتورة مشتريات",
    "propose_create_customer": "عميلًا جديدًا",
    "propose_update_customer": "تعديلًا على عميل",
    "get_project_overview": "نظرة عامة على المشروع",
    "get_project_financials": "البيانات المالية",
    "list_project_signals": "التنبيهات",
    "list_milestones": "المعالم الرئيسية",
    "list_project_tasks": "المهام",
    "get_billing_status": "الفوترة",
    "list_cost_documents": "مستندات التكلفة",
    "get_time_summary": "الساعات المسجّلة",
    "get_weekly_changes": "تغييرات هذا الأسبوع",
    "get_contract_status": "العقد",
    "get_trial_balance": "ميزان المراجعة",
    "get_profit_and_loss": "الأرباح والخسائر",
    "get_balance_sheet": "الميزانية العمومية",
    "get_cash_flow": "التدفقات النقدية",
    "get_vat_return": "إقرار ضريبة القيمة المضافة",
    "find_accounts": "الحسابات",
    "get_account_movements": "حركات الحساب",
    "get_receivables_aging": "أعمار الذمم المدينة",
    "get_payables_aging": "أعمار الذمم الدائنة",
    "list_expenses": "المصروفات",
    "get_bank_status": "حالة التسوية البنكية",
    "get_books_health": "سلامة الدفاتر",
    "get_drilldown": "حركات الرقم",
    "get_account_roles": "ربط الحسابات",
    "list_expense_categories": "فئات المصروفات",
    "get_bank_statement_lines": "سطور الكشف",
    "get_payee_history": "مصروفات المستفيد السابقة",
    "get_stock_overview": "نظرة عامة على المخزون",
    "find_stock_items": "منتجات المخزون",
    "get_item_stock": "مخزون المنتج",
    "list_stock_movements": "حركات المخزون",
    "get_stock_checks": "فحوص المخزون",
    "get_reorder_suggestions": "مقترحات إعادة الطلب",
    "get_stock_valuation": "تقييم المخزون",
    "get_stock_adjustments": "تسويات المخزون",
    "list_stock_transfers": "تحويلات المخزون",
    "list_warehouses": "المستودعات",
    "propose_stock_task": "مهمة متابعة",
    "propose_stock_transfer": "مسودة تحويل",
    "propose_draft_purchase": "مسودة فاتورة شراء",
    "propose_reorder_level": "حد إعادة الطلب",
    "find_suppliers": "الموردين",
    "list_supplier_items": "ما باعه لك هذا المورد من قبل",
    "find_purchase_items": "منتجاتك",
    "find_service_sites": "مواقع الخدمة",
    "get_service_site": "الموقع",
    "get_site_places": "أماكن الموقع",
    "list_place_assets": "معدات المكان",
    "list_asset_types": "أنواع الأصول",
    "list_site_templates": "قوالب المواقع",
    "find_service_customers": "العملاء",
    "propose_service_site": "موقع جديد",
    "propose_generate_places": "أماكن تُضاف",
    "propose_duplicate_place": "مكان يُنسخ",
    "propose_place_assets": "معدات تُضاف",
    "find_service_contracts": "عقود الصيانة",
    "get_service_contract": "العقد",
    "get_asset_checks": "فحوص المعدة",
    "find_records": "السجلات",
    "get_record": "السجل",
    "run_report": "التقرير"
  },
  "chip": {
    "running": "جارٍ قراءة {{what}}…",
    "done": "تمت قراءة {{what}}",
    "failed": "تعذّرت قراءة {{what}}",
    "unknown": "بيانات المشروع",
    "records_zero": "لا سجلات",
    "records_one": "سجل واحد",
    "records_two": "سجلان",
    "records_few": "{{n}} سجلات",
    "records_many": "{{n}} سجلًا",
    "records_other": "{{n}} سجل",
    "none": "لا سجلات لعرضها.",
    "read": "قرأ: {{list}}"
  },
  "proposals": {
    "propose_record_receipt": {
      "title": "تسجيل مقبوض بمبلغ {{amount}} من {{customer}}",
      "fields": {
        "receiptDate": "تاريخ القبض",
        "reference": "المرجع"
      },
      "note": "دُفع بطريقة {{method}} في {{account}} بتاريخ {{date}}. يسدّد {{allocated}} الفواتير أدناه، ويبقى الباقي ({{credit}}) رصيدًا دائنًا للعميل. إن تغيّر رصيد قبل أن تؤكّد، تُرفض البطاقة.",
      "open": "فتح المقبوض"
    },
    "propose_pay_supplier": {
      "title": "دفع {{amount}} إلى {{supplier}}",
      "fields": {
        "paymentDate": "تاريخ الدفع",
        "reference": "المرجع"
      },
      "note": "يُدفع بطريقة {{method}} من {{account}} بتاريخ {{date}}. يسدّد {{allocated}} المشتريات أدناه، ويبقى الباقي ({{advance}}) دفعة مقدّمة للمورّد. إن تغيّر رصيد قبل أن تؤكّد، تُرفض البطاقة.",
      "open": "فتح الدفعة"
    },
    "propose_post_purchase": {
      "title": "ترحيل مسودة الشراء من {{supplier}}",
      "note": "يمنح الترحيلُ الشراءَ رقمه ({{total}}، بتاريخ {{date}})، ويسجّل ما عليك للمورّد، ويستلم بنوده المخزنية ({{goods}} من {{count}}) في المستودع {{warehouse}}. بعد الترحيل لا يُعدَّل، بل يُلغى فقط.",
      "open": "فتح الشراء"
    },
    "propose_void_purchase": {
      "title": "إلغاء الشراء {{number}} من {{supplier}}",
      "fields": {
        "reason": "السبب"
      },
      "note": "يعكس الإلغاءُ الشراءَ في الدفاتر وحساب المورّد ويُخرج بضاعته من المخزون. الإجمالي {{total}}، المدفوع {{paid}}. إن دُفع أو تغيّر قبل أن تؤكّد، تُرفض البطاقة.",
      "open": "فتح الشراء"
    },
    "propose_post_credit_note": {
      "title": "ترحيل مسودة الإشعار الدائن لـ {{customer}}",
      "note": "يمنح الترحيلُ الإشعارَ الدائن رقمه ({{total}}، بتاريخ {{date}}؛ الفاتورة المعنية {{invoice}}) ويسجّله في الدفاتر وحساب العميل. بعد الترحيل لا يُعدَّل، بل يُلغى فقط.",
      "open": "فتح الإشعار الدائن"
    },
    "propose_void_credit_note": {
      "title": "إلغاء الإشعار الدائن {{number}} لـ {{customer}}",
      "fields": {
        "reason": "السبب"
      },
      "note": "يعكس الإلغاءُ الإشعارَ في الدفاتر وحساب العميل. الإجمالي {{total}}، المخصّص {{allocated}}، المردود {{refunded}}. إن استُخدم أو تغيّر قبل أن تؤكّد، تُرفض البطاقة.",
      "open": "فتح الإشعار الدائن"
    },
    "propose_archive_customer": {
      "title": "أرشفة العميل {{name}}",
      "note": "الرمز {{code}}. تُخرج الأرشفةُ العميلَ من القوائم والمستندات الجديدة. لا يُحذف شيء: تبقى مستنداته وسجله، ويمكنك استعادته من صفحته.",
      "open": "فتح العميل"
    },
    "propose_archive_supplier": {
      "title": "أرشفة المورّد {{name}}",
      "note": "الرمز {{code}}. تُخرج الأرشفةُ المورّدَ من القوائم والمستندات الجديدة. لا يُحذف شيء، ويمكنك استعادته من صفحته. لا يُؤرشف مورّد ما زلت مدينًا له.",
      "open": "فتح المورّد"
    },
    "propose_archive_product": {
      "title": "أرشفة المنتج {{name}}",
      "note": "رمز الصنف {{code}}. تُخرج الأرشفةُ المنتجَ من القوائم والمستندات الجديدة. لا يُحذف شيء، ويمكنك استعادته من صفحته. لا يُؤرشف منتج له مخزون متوفر.",
      "open": "فتح المنتج"
    },
    "sensitive": "تغيير حساس",
    "sensitiveHint": "يُرحّل أو يُلغي أو ينقل مالًا أو يؤرشف. اقرأ البطاقة قبل أن تؤكّد.",
    "propose_post_invoice": {
      "title": "ترحيل مسودة الفاتورة لـ {{customer}}",
      "note": "يمنح الترحيلُ الفاتورةَ رقمها ({{count}} بنود، {{total}}) ويسجّلها في الدفاتر وحساب العميل. ولا تُصحَّح بعد ذلك إلا بإشعار دائن أو بالإلغاء.",
      "open": "فتح الفاتورة"
    },
    "propose_void_invoice": {
      "title": "إلغاء الفاتورة {{number}} لـ {{customer}}",
      "fields": {
        "reason": "السبب"
      },
      "note": "يعكس الإلغاءُ الفاتورةَ في الدفاتر وحساب العميل. الإجمالي {{total}}، المدفوع {{paid}}. إن دُفعت أو تغيّرت قبل أن تؤكّد، تُرفض البطاقة.",
      "open": "فتح الفاتورة"
    },
    "changes": {
      "caption": "ما تغيّره البطاقة",
      "before": "الآن",
      "after": "بعد التغيير",
      "all": "عرض الكل ({{n}})",
      "fewer": "عرض أقل"
    },
    "propose_create_supplier": {
      "title": "إضافة المورد {{name}}",
      "fields": {
        "name": "الاسم",
        "nameAr": "الاسم بالعربية",
        "company": "الشركة",
        "contactPerson": "جهة الاتصال",
        "mobile": "الهاتف المحمول",
        "email": "البريد الإلكتروني",
        "city": "المدينة"
      },
      "open": "فتح المورد"
    },
    "propose_update_supplier": {
      "title": "تعديل المورد {{code}} {{name}}",
      "fields": {
        "name": "الاسم",
        "nameAr": "الاسم بالعربية",
        "company": "الشركة",
        "contactPerson": "جهة الاتصال",
        "mobile": "الهاتف المحمول",
        "email": "البريد الإلكتروني",
        "city": "المدينة",
        "status": "الحالة"
      },
      "statuses": {
        "ACTIVE": "نشط",
        "INACTIVE": "غير نشط"
      },
      "note": "تتغيّر الحقول المعروضة فقط. إن عدّل أحدهم هذا المورد قبل أن تؤكّد، تُرفض البطاقة.",
      "open": "فتح المورد"
    },
    "propose_update_prices": {
      "title_zero": "تغيير الأسعار",
      "title_one": "تغيير سعر {{name}}",
      "title_two": "تغيير سعرين",
      "title_few": "تغيير {{count}} أسعار",
      "title_many": "تغيير {{count}} سعرًا",
      "title_other": "تغيير {{count}} سعر",
      "note": "إن لم يعد أي سعر هو المعروض حين تؤكّد، لا يتغيّر شيء وتُرفض البطاقة.",
      "open": "فتح المنتج"
    },
    "propose_adjust_stock": {
      "title": "تسوية المخزون في {{warehouse}}",
      "titleCount": "تسجيل جرد المخزون في {{warehouse}}",
      "fields": {
        "reason": "السبب",
        "notes": "ملاحظات"
      },
      "reasons": {
        "DAMAGE": "تالف",
        "EXPIRED": "منتهي الصلاحية",
        "THEFT_LOSS": "سرقة أو فقدان",
        "FOUND": "عُثر عليه",
        "CORRECTION": "تصحيح",
        "OTHER": "أخرى"
      },
      "note": "يُقيَّم المخزون المضاف بمتوسط تكلفة الصنف. إن تحرّك المخزون قبل أن تؤكّد، تُرفض البطاقة.",
      "open": "فتح التسوية"
    },
    "propose_draft_invoice": {
      "title": "مسودة فاتورة لـ {{customer}}",
      "fields": {
        "invoiceDate": "تاريخ الفاتورة",
        "reference": "المرجع"
      },
      "note": "مسودة: لا يُرحَّل شيء ولا يتحرّك المخزون. ترحّلها من صفحتها.",
      "open": "فتح المسودة"
    },
    "propose_draft_quotation": {
      "title": "عرض سعر لـ {{customer}}",
      "fields": {
        "quotationDate": "تاريخ العرض",
        "reference": "المرجع"
      },
      "note": "لا أثر لعرض السعر في الدفاتر ولا في المخزون حتى يصبح فاتورة.",
      "open": "فتح عرض السعر"
    },
    "propose_draft_purchase_bill": {
      "title": "مسودة فاتورة مشتريات من {{supplier}}",
      "fields": {
        "purchaseDate": "تاريخ الفاتورة",
        "supplierReference": "رقم فاتورة المورد"
      },
      "note": "مسودة: لا يُستلم شيء ولا يُرحَّل. ترحّلها من صفحتها.",
      "open": "فتح المسودة"
    },
    "propose_create_customer": {
      "title": "إضافة العميل {{name}}",
      "fields": {
        "name": "الاسم",
        "nameAr": "الاسم بالعربية",
        "company": "الشركة",
        "mobile": "الهاتف المحمول",
        "email": "البريد الإلكتروني",
        "city": "المدينة"
      },
      "open": "فتح العميل"
    },
    "propose_update_customer": {
      "title": "تعديل العميل {{code}} {{name}}",
      "fields": {
        "name": "الاسم",
        "nameAr": "الاسم بالعربية",
        "company": "الشركة",
        "mobile": "الهاتف المحمول",
        "email": "البريد الإلكتروني",
        "city": "المدينة",
        "status": "الحالة"
      },
      "statuses": {
        "ACTIVE": "نشط",
        "INACTIVE": "غير نشط"
      },
      "note": "تتغيّر الحقول المعروضة فقط. إن عدّل أحدهم هذا العميل قبل أن تؤكّد، تُرفض البطاقة.",
      "open": "فتح العميل"
    },
    "label": "مقترح",
    "status": {
      "PENDING": "بانتظار قرارك",
      "APPROVED": "مؤكَّد",
      "EXECUTED": "نُفّذ",
      "REJECTED": "مرفوض",
      "EXPIRED": "منتهي الصلاحية",
      "FAILED": "تعذّر التنفيذ"
    },
    "edit": "تعديل",
    "doneEditing": "إنهاء التعديل",
    "confirm": "تأكيد",
    "discard": "رفض",
    "discardReason": "أخبر المساعد بالسبب (اختياري)",
    "discardConfirm": "رفض المقترح",
    "undo": "تراجع",
    "edited": "عدّلته أنت",
    "expires": "قرّر قبل {{time}}",
    "waitingConfirm": "أُكِّد. قرّر بشأن المقترحات الأخرى للمتابعة.",
    "waitingDiscard": "رُفض. قرّر بشأن المقترحات الأخرى للمتابعة.",
    "running": "جارٍ التنفيذ…",
    "confirmedBody": "أُكِّد، ونفّذه المساعد بحسابك.",
    "openResult": "فتح {{label}}",
    "discardedBody": "لم يتغيّر شيء.",
    "expiredBody": "انتهت صلاحية هذا المقترح قبل تأكيده. اسأل مرة أخرى لتحصل على مقترح جديد.",
    "failedBody": "لم يُنفَّذ. {{reason}}",
    "failure": {
      "VALIDATION_FAILED": "لم تعد قيمه تستوفي شروط هذا الإجراء. اسأل المساعد مرة أخرى أو نفّذه بنفسك.",
      "UNKNOWN_TOOL": "لم يعد بإمكان المساعد تنفيذ هذا. اسأل مرة أخرى أو نفّذه بنفسك.",
      "NOT_FOUND": "السجل المعني لم يعد موجودًا، أو لم تعد لديك صلاحية رؤيته."
    },
    "required": "أدخل {{field}}.",
    "fallbackTitle": "تغيير يقترحه المساعد",
    "empty": "—",
    "propose_create_task": {
      "title": "إنشاء المهمة «{{title}}»",
      "fields": {
        "title": "المهمة",
        "description": "التفاصيل",
        "dueDate": "تاريخ الاستحقاق",
        "priority": "الأولوية"
      },
      "priority": {
        "LOW": "منخفضة",
        "NORMAL": "عادية",
        "HIGH": "عالية",
        "URGENT": "عاجلة"
      }
    },
    "propose_milestone_forecast": {
      "title": "نقل المعلم الرئيسي {{milestone}} إلى {{date}}",
      "fields": {
        "plannedFinish": "التاريخ الجديد"
      },
      "note": "يبقى اسم المعلم كما هو، ويتغيّر تاريخه المخطط فقط."
    },
    "propose_acknowledge_signal": {
      "title": "تأجيل التنبيه «{{signal}}»",
      "fields": {
        "note": "السبب",
        "untilOn": "مؤجَّل حتى"
      },
      "note": "تتوقف إشعاراته حتى ذلك التاريخ، ويبقى محسوبًا في سلامة المشروع."
    },
    "reason": "سببك: {{reason}}",
    "propose_books_task": {
      "title": "إنشاء المهمة «{{title}}»",
      "fields": {
        "title": "المهمة",
        "description": "التفاصيل",
        "dueDate": "تاريخ الاستحقاق",
        "priority": "الأولوية"
      },
      "priority": {
        "LOW": "منخفضة",
        "NORMAL": "عادية",
        "HIGH": "عالية",
        "URGENT": "عاجلة"
      }
    },
    "propose_create_expense_category": {
      "title": "إنشاء فئة المصروفات «{{name}}» تُرحَّل إلى {{account}}",
      "fields": {
        "name": "الاسم",
        "nameAr": "الاسم بالعربية"
      }
    },
    "propose_create_account": {
      "title": "إنشاء الحساب {{code}} «{{name}}»",
      "fields": {
        "code": "الرمز",
        "name": "الاسم",
        "nameAr": "الاسم بالعربية"
      },
      "note": "النوع: {{type}}. يتبع: {{parent}}."
    },
    "propose_map_account_role": {
      "title": "ربط «{{role}}» بالحساب {{account}}",
      "note": "مربوط الآن بـ: {{current}}. تُرحَّل القيود المستقبلية لهذا الدور إلى الحساب الجديد، وتبقى الأرصدة المرحّلة سابقًا في مكانها."
    },
    "propose_bank_match": {
      "title": "مطابقة السطر {{lineNo}} من {{statement}} ({{txnDate}}، {{amount}}) مع القيد {{entry}} بتاريخ {{entryDate}}",
      "line": "سطر الكشف",
      "entry": "القيد في الدفاتر",
      "reason": "السبب"
    },
    "propose_bank_adjustment": {
      "title": "قيد تعديل بنكي بمبلغ {{amount}} إلى {{account}}",
      "fields": {
        "description": "الوصف"
      },
      "postsJournal": "التأكيد يرحّل قيد يومية في الدفاتر بتاريخ السطر ({{txnDate}}) بين الحساب البنكي وهذا الحساب، ويطابق السطر {{lineNo}} من {{statement}} معه. لا يُلغى إلا بعكس القيد.",
      "confirm": "تأكيد وترحيل"
    },
    "propose_dismiss_finding": {
      "title": "اعتبار «{{code}}» ليست مشكلة",
      "fields": {
        "reason": "لماذا ليست مشكلة",
        "untilOn": "حتى"
      },
      "howLong": "إلى متى",
      "note": "تبقى ظاهرة في سلامة الدفاتر بلون باهت، مع اسمك والسبب.",
      "titleFinding": "اعتبار «{{title}}» ليست مشكلة",
      "until": "حتى {{date}}",
      "forGood": "لهذا البند (نهائيًا)",
      "editNote": "اترك «حتى» فارغًا لاستبعادها نهائيًا لهذا البند."
    },
    "lines": {
      "caption": "بنود المسودة",
      "item": "المنتج",
      "quantity": "الكمية",
      "unitPrice": "سعر الوحدة",
      "amount": "المبلغ",
      "total": "الإجمالي التقديري",
      "count_zero": "لا بنود",
      "count_one": "بند واحد",
      "count_two": "بندان",
      "count_few": "{{n}} بنود",
      "count_many": "{{n}} بندًا",
      "count_other": "{{n}} بند",
      "all": "عرض كل البنود ({{n}})",
      "fewer": "عرض أقل",
      "scroll": "بنود المسودة؛ مرّر أفقيًا لرؤية كل الأعمدة"
    },
    "propose_stock_task": {
      "title": "إنشاء المهمة «{{title}}»",
      "fields": {
        "title": "المهمة",
        "description": "التفاصيل",
        "dueDate": "تاريخ الاستحقاق",
        "priority": "الأولوية"
      },
      "priority": {
        "LOW": "منخفضة",
        "NORMAL": "عادية",
        "HIGH": "عالية",
        "URGENT": "عاجلة"
      },
      "open": "فتح المهمة"
    },
    "propose_stock_transfer": {
      "title": "إنشاء مسودة تحويل من {{from}} إلى {{to}}",
      "fields": {
        "transferDate": "تاريخ التحويل",
        "notes": "ملاحظات"
      },
      "draftNote": "التأكيد ينشئ مسودة تحويل بهذه البنود. لا يُنقل شيء حتى ترحّلها، ويمكنك تعديلها في صفحتها قبل ذلك.",
      "confirm": "إنشاء المسودة",
      "done": "أُنشئت المسودة. لا يُنقل شيء حتى ترحّلها.",
      "open": "فتح مسودة التحويل",
      "left_zero": "لم يبقَ أي منتج لمسودة أخرى.",
      "left_one": "بقي منتج واحد لمسودة أخرى.",
      "left_two": "بقي منتجان لمسودة أخرى.",
      "left_few": "بقيت {{n}} منتجات لمسودة أخرى.",
      "left_many": "بقي {{n}} منتجًا لمسودة أخرى.",
      "left_other": "بقي {{n}} منتج لمسودة أخرى."
    },
    "propose_draft_purchase": {
      "title": "إنشاء مسودة فاتورة شراء من {{supplier}}",
      "fields": {
        "purchaseDate": "تاريخ الشراء",
        "notes": "ملاحظات"
      },
      "warehouse": "الاستلام في",
      "draftNote": "التأكيد ينشئ مسودة فاتورة شراء بهذه البنود. لا يُطلب شيء ولا يُستلم حتى ترحّلها، ويمكنك تعديلها في صفحتها قبل ذلك.",
      "confirm": "إنشاء المسودة",
      "done": "أُنشئت المسودة. لا يُطلب شيء ولا يُستلم حتى ترحّلها.",
      "open": "فتح مسودة فاتورة الشراء",
      "left_zero": "لم يبقَ أي منتج لمسودة أخرى.",
      "left_one": "بقي منتج واحد لمسودة أخرى.",
      "left_two": "بقي منتجان لمسودة أخرى.",
      "left_few": "بقيت {{n}} منتجات لمسودة أخرى.",
      "left_many": "بقي {{n}} منتجًا لمسودة أخرى.",
      "left_other": "بقي {{n}} منتج لمسودة أخرى."
    },
    "propose_reorder_level": {
      "title": "تحديد حد إعادة الطلب للمنتج {{item}}",
      "fields": {
        "reorderLevel": "حد إعادة الطلب الجديد"
      },
      "note": "حد إعادة الطلب الآن: {{current}}. يسري الحد الجديد على المنتج في كل المستودعات.",
      "done": "كان {{current}}.",
      "open": "فتح حركات المنتج"
    },
    "propose_service_site": {
      "title": "موقع جديد «{{name}}» للعميل {{customer}}",
      "fields": {
        "name": "اسم الموقع",
        "address": "العنوان",
        "code": "الرمز"
      },
      "note": "يضيف التأكيد الموقع إلى العميل. تأتي أماكنه ومعداته بعد ذلك، في صفحته أو هنا.",
      "open": "فتح الموقع"
    },
    "propose_generate_places": {
      "title": "إضافة أماكن إلى {{site}}",
      "note": "تحت: {{under}}. أماكن جديدة: {{create}}. موجودة من قبل وتبقى كما هي: {{existing}}. أولها: {{first}}.",
      "noPlace": "المستوى الأعلى من الموقع",
      "open": "فتح الموقع"
    },
    "propose_duplicate_place": {
      "title": "نسخ {{place}} في {{site}}",
      "note": "النسخ: {{copies}}. أماكن جديدة: {{create}}. موجودة من قبل وتبقى كما هي: {{existing}}. المعدات المنسوخة: {{assets}}. أولها: {{first}}.",
      "open": "فتح الموقع"
    },
    "propose_place_assets": {
      "title": "إضافة {{count}} × {{type}} في {{place}}",
      "fields": {
        "count": "العدد",
        "position": "الموضع",
        "brand": "العلامة التجارية",
        "model": "الطراز"
      },
      "note": "الموقع: {{site}}. يحصل كل واحد على وسمه الخاص.",
      "noPlace": "الموقع نفسه",
      "open": "فتح الموقع"
    }
  },
  "errors": {
    "AI_DISABLED": "أوقف مزوّد خدمة سحاب لديكم المساعد الذكي. تواصل معه إن أردت استخدامه.",
    "AI_BLOCKED_BY_POLICY": "لا يمكن تشغيل المساعد الذكي لشركتك الآن. يمكن للمسؤول مراجعة الإعدادات › المساعد الذكي.",
    "AI_KEY_MISSING": "على المسؤول إضافة مفتاح OpenAI الخاص بالشركة في الإعدادات › المساعد الذكي.",
    "AI_ACK_REQUIRED": "على أحد المسؤولين قبول شروط المساعد الذكي أولًا في الإعدادات › المساعد الذكي.",
    "AI_LIMIT_ABOVE_CAP": "الحد الشهري للشركة أعلى مما يسمح به مزوّد خدمة سحاب لديكم، ويمكن للمسؤول خفضه.",
    "AI_MODEL_NOT_ALLOWED": "النموذج المختار غير مسموح به. يمكن للمسؤول اختيار نموذج آخر في الإعدادات › المساعد الذكي.",
    "AI_BUDGET_EXCEEDED": "استُنفد رصيد المساعد الذكي لشركتك هذا الشهر. يمكن للمسؤول رفعه في الإعدادات › المساعد الذكي.",
    "AI_BUDGET_EXCEEDED_user_daily": "استنفدت أسئلتك لهذا اليوم.",
    "AI_RUN_IN_PROGRESS": "لديك سؤال قيد التنفيذ. انتظر حتى ينتهي أو أوقفه، ثم اسأل مرة أخرى.",
    "AI_RUN_EXPIRED": "انتهت صلاحية هذه المقترحات. اسأل مرة أخرى لتحصل على مقترحات جديدة.",
    "AI_RESUME_INCOMPATIBLE": "حُدّث المساعد الذكي بعد هذه المقترحات. اسأل مرة أخرى لتحصل على مقترحات جديدة.",
    "AI_NOT_ALLOWED": "لا يمكن لهذا الحساب استخدام المساعد الذكي. سجّل الدخول بحسابك الشخصي.",
    "AI_PROVIDER_AUTH": "رفضت OpenAI مفتاح الشركة. على المسؤول التحقق من المفتاح في الإعدادات › المساعد الذكي.",
    "AI_PROVIDER_UNAVAILABLE": "تعذّر الوصول إلى OpenAI حاليًا. حاول مرة أخرى بعد دقائق.",
    "AI_PROVIDER_RATE_LIMITED": "تحدّ OpenAI من الطلبات بمفتاح شركتك. حاول مرة أخرى بعد دقيقة.",
    "AI_TURN_LIMIT": "احتاج السؤال إلى خطوات كثيرة. اسأل عن أمر أضيق.",
    "AI_MODEL_ERROR": "تعذّر استخدام إجابة المساعد. حاول مرة أخرى أو أعد صياغة السؤال.",
    "AI_TIMEOUT": "استغرق المساعد وقتًا طويلًا في الإجابة. حاول مرة أخرى أو اسأل عن أمر أضيق.",
    "PLAN_TOO_LARGE": "يمكن إضافة 20 مرحلة و200 مهمة على الأكثر في المرة الواحدة. احذف بعضها أو أضف الخطة على دفعتين.",
    "FORBIDDEN": "لم تعد لديك صلاحية تنفيذ هذا. اطلب الصلاحية من المسؤول إن احتجت إليها.",
    "RATE_LIMITED": "طرحت أسئلة كثيرة في وقت قصير. انتظر قليلًا ثم حاول مرة أخرى.",
    "RATE_LIMITED_wait_zero": "طرحت أسئلة كثيرة في وقت قصير. حاول مرة أخرى بعد لحظات.",
    "RATE_LIMITED_wait_one": "طرحت أسئلة كثيرة في وقت قصير. حاول مرة أخرى بعد ثانية واحدة.",
    "RATE_LIMITED_wait_two": "طرحت أسئلة كثيرة في وقت قصير. حاول مرة أخرى بعد ثانيتين.",
    "RATE_LIMITED_wait_few": "طرحت أسئلة كثيرة في وقت قصير. حاول مرة أخرى بعد {{n}} ثوانٍ.",
    "RATE_LIMITED_wait_many": "طرحت أسئلة كثيرة في وقت قصير. حاول مرة أخرى بعد {{n}} ثانية.",
    "RATE_LIMITED_wait_other": "طرحت أسئلة كثيرة في وقت قصير. حاول مرة أخرى بعد {{n}} ثانية.",
    "STREAM_ENDED": "انقطعت الإجابة. حاول مرة أخرى.",
    "AI_ATTACHMENTS_NOT_ACCEPTED": "هذا الجزء من المساعد لا يقرأ المستندات. اكتب السؤال بدلًا من ذلك.",
    "AI_TOO_MANY_ATTACHMENTS": "مستندات كثيرة في مرة واحدة. أزل بعضها ثم حاول مرة أخرى.",
    "unknown": "تعذّر على المساعد تنفيذ ذلك. حاول مرة أخرى، وإن تكرر فأبلغ المسؤول.",
    "AI_DOCUMENT_TOO_LONG": "في ملف PDF صفحات أكثر مما يقرؤه المساعد في مرة واحدة. أرسله على أجزاء.",
    "AI_DOCUMENT_UNREADABLE": "تعذّرت قراءة ملف PDF: قد يكون تالفًا أو محميًا بكلمة مرور، أو أكبر مما يُقرأ في مرة واحدة. أرسل صورًا لصفحاته بدلًا منه.",
    "AI_BUSY": "المساعد يقرأ مستندات أخرى الآن. حاول مرة أخرى بعد دقيقة."
  },
  "unavailable": {
    "disabled": "أوقف مزوّد خدمة سحاب لديكم المساعد الذكي. تواصل معه إن أردت استخدامه.",
    "module_off": "المساعد الذكي ليس ضمن اشتراك شركتك، ويمكن لمزوّد خدمة سحاب لديكم إضافته.",
    "no_policy": "لم يُعدّ مزوّد خدمة سحاب لديكم المساعد الذكي لشركتك بعد.",
    "suspended": "أوقف مزوّد خدمة سحاب لديكم المساعد الذكي لشركتك مؤقتًا.",
    "not_enabled": "المساعد الذكي غير مفعّل. يمكن للمسؤول تفعيله في الإعدادات › المساعد الذكي.",
    "no_key": "على المسؤول إضافة مفتاح OpenAI الخاص بالشركة في الإعدادات › المساعد الذكي.",
    "residency": "تحتفظ شركتك ببياناتها في عُمان، وعلى المسؤول الموافقة على إرسالها إلى OpenAI في الإعدادات › المساعد الذكي.",
    "not_allowed": "لا يملك حسابك صلاحية استخدام المساعد الذكي. تواصل مع المسؤول.",
    "feature_off": "هذا الجزء من المساعد الذكي متوقف. يمكن للمسؤول تشغيله في الإعدادات › المساعد الذكي.",
    "area_off": "هذا الجزء من المساعد الذكي غير مشمول لشركتك، ويمكن لمزوّد خدمة سحاب لديكم إضافته."
  },
  "unverified": "رقم غير مؤكَّد",
  "unverifiedList": "تحقّق من هذه الأرقام، فلم تُرجعها بيانات المشروع:",
  "explain": {
    "action": "شرح «{{title}}» بالمساعد الذكي",
    "thisAlert": "هذا التنبيه",
    "ruleBased": "من قاعدة التنبيه نفسها، دون المساعد",
    "rule": "{{dimension}}: {{body}}",
    "thresholds": "الحدود من إعدادات المؤشرات في شركتك."
  },
  "run": {
    "working": "المساعد الذكي يعمل…",
    "stop": "إيقاف",
    "stopped": "أُوقف.",
    "retry": "حاول مرة أخرى",
    "unreadable": "تعذّرت قراءة إجابة المساعد. حاول مرة أخرى."
  },
  "statusDraft": {
    "action": "اكتب مسودة بالمساعد الذكي",
    "title": "مسودة بالمساعد الذكي",
    "description": "يكتب المساعد الأقسام الأربعة من بيانات هذا المشروع عن {{week}}، وتبقى الأرقام الرئيسية مأخوذة من سجل الأسبوع.",
    "prompt": "اكتب مسودة تقرير الحالة الأسبوعي للأسبوع الذي يبدأ في {{weekStart}}.",
    "use": "استخدام هذه المسودة",
    "create": "إنشاء التقرير من هذه المسودة",
    "replaceTitle": "استبدال النص الذي كتبته؟",
    "replaceBody": "تُستبدل الأقسام الأربعة بمسودة المساعد، ولا يُحفظ شيء حتى تحفظ التقرير.",
    "replaceConfirm": "استبدال النص",
    "filled": "أُدرجت المسودة. تحقّق من الأرقام قبل الحفظ.",
    "note": "كُتب بمساعدة المساعد الذكي. تحقّق من الأرقام قبل الحفظ."
  },
  "plan": {
    "action": "تقسيم نطاق العمل إلى مراحل",
    "title": "تقسيم نطاق العمل إلى مراحل",
    "description": "صِف العمل، فيقترح المساعد المراحل والمعالم الرئيسية والمهام، وتعدّلها أنت قبل إضافة أي شيء إلى الخطة.",
    "scope": "نطاق العمل",
    "scopeHint": "الصق نطاق العمل أو صِفه بكلماتك، بحد أقصى {{max}} حرف.",
    "propose": "اقتراح المراحل",
    "again": "البدء من جديد",
    "anchor": "تُحسب التواريخ بأيام العمل من {{date}} وفق تقويم الشركة.",
    "counts": "المراحل: {{phases}} · المعالم الرئيسية: {{milestones}} · المهام: {{tasks}}",
    "phase": "المرحلة {{n}}",
    "phaseName": "اسم المرحلة",
    "phaseNameAr": "الاسم بالعربية",
    "offset": "تبدأ بعد (أيام عمل)",
    "duration": "المدة (أيام عمل)",
    "weight": "الوزن %",
    "dates": "{{start}} – {{end}}",
    "milestones": "المعالم الرئيسية",
    "milestoneName": "المعلم الرئيسي",
    "milestoneOffset": "يُستحق بعد (أيام عمل)",
    "tasks": "المهام",
    "taskTitle": "المهمة",
    "taskOffset": "تُستحق بعد (أيام عمل)",
    "noDue": "بلا تاريخ استحقاق",
    "addPhase": "إضافة مرحلة",
    "addMilestone": "إضافة معلم رئيسي",
    "addTask": "إضافة مهمة",
    "remove": "حذف {{name}}",
    "unnamed": "هذا الصف",
    "assumptions": "افترض المساعد ما يلي",
    "apply": "إضافة إلى الخطة",
    "tooMany": "يمكن إضافة {{phases}} مرحلة و{{tasks}} مهمة على الأكثر في المرة الواحدة.",
    "nameRequired": "يحتاج كل صف من المراحل والمعالم والمهام إلى اسم.",
    "empty": "لم يقترح المساعد أي مرحلة. أضف تفاصيل أكثر إلى نطاق العمل وحاول مرة أخرى.",
    "applied_zero": "لم تُضف أي مرحلة إلى الخطة",
    "applied_one": "أُضيفت مرحلة واحدة إلى الخطة",
    "applied_two": "أُضيفت مرحلتان إلى الخطة",
    "applied_few": "أُضيفت {{n}} مراحل إلى الخطة",
    "applied_many": "أُضيفت {{n}} مرحلة إلى الخطة",
    "applied_other": "أُضيفت {{n}} مرحلة إلى الخطة",
    "start": "بدء المراحل الجديدة في",
    "after_zero": "تُضاف بعد مراحل الخطة الحالية.",
    "after_one": "تُضاف بعد المرحلة الحالية في الخطة.",
    "after_two": "تُضاف بعد المرحلتين الحاليتين في الخطة.",
    "after_few": "تُضاف بعد المراحل الـ{{n}} الحالية في الخطة.",
    "after_many": "تُضاف بعد المراحل الـ{{n}} الحالية في الخطة.",
    "after_other": "تُضاف بعد المراحل الـ{{n}} الحالية في الخطة.",
    "tooLong": "النص أطول من {{max}} حرف، فلم يُلصق. اختصره ثم الصقه مرة أخرى.",
    "againTitle": "البدء من جديد؟",
    "againBody": "تُحذف تعديلاتك على المراحل المقترحة، وتصف نطاق العمل من جديد."
  },
  "boq": {
    "mappingTitle": "مطابقة أعمدة الملف",
    "mappingBody": "عناوين أعمدة هذا الملف تختلف عن عناوين الاستيراد. حدّد محتوى كل عمود، ليُستورد الملف بهذه الأعمدة.",
    "suggest": "اقتراح مطابقة الأعمدة",
    "suggestHint": "لا يُرسل إلى المساعد إلا صف العناوين وأول 5 صفوف.",
    "column": "العمود في الملف",
    "sample": "القيمة الأولى",
    "field": "يُستورد بوصفه",
    "confidence": "درجة الثقة",
    "notImported": "لا يُستورد",
    "suggested": "اقترحها المساعد الذكي. راجع كل عمود ثم أكّد المطابقة.",
    "confirm": "تأكيد هذه المطابقة",
    "missing": "طابِق أعمدة {{fields}} أولًا.",
    "duplicate": "اختير «{{field}}» لأكثر من عمود.",
    "checkTitle": "فحص الكمية × السعر",
    "checkOk": "مبلغ كل صف يساوي الكمية × السعر.",
    "checkSkipped": "طابِق الكمية والسعر والمبلغ لفحص مبالغ الصفوف.",
    "mismatches_zero": "لا صفوف يختلف مبلغها عن الكمية × السعر.",
    "mismatches_one": "صف واحد يختلف مبلغه عن الكمية × السعر:",
    "mismatches_two": "صفان يختلف مبلغهما عن الكمية × السعر:",
    "mismatches_few": "{{n}} صفوف تختلف مبالغها عن الكمية × السعر:",
    "mismatches_many": "{{n}} صفًا تختلف مبالغها عن الكمية × السعر:",
    "mismatches_other": "{{n}} صف تختلف مبالغها عن الكمية × السعر:",
    "mismatch": "الصف {{row}}: {{qty}} × {{rate}} = {{expected}}، وفي الملف {{amount}}",
    "more": "و{{n}} غيرها",
    "continue": "معاينة الاستيراد",
    "back": "تغيير المطابقة",
    "lowConfidence": "تحقّق منه",
    "fields": {
      "section_path": "القسم",
      "item_no": "رقم البند",
      "description": "الوصف",
      "description_ar": "الوصف بالعربية",
      "unit": "الوحدة",
      "quantity": "الكمية",
      "rate": "السعر",
      "amount": "المبلغ",
      "kind": "النوع",
      "measure_by": "طريقة القياس",
      "wbs_code": "جزء الخطة",
      "cost_category": "فئة التكلفة",
      "cost_rate": "سعر التكلفة"
    }
  },
  "assisted": "بمساعدة الذكاء الاصطناعي",
  "table": {
    "copy": "نسخ بصيغة CSV",
    "copied": "نُسخ الجدول بصيغة CSV",
    "copyFailed": "تعذّر نسخ الجدول. حدّده وانسخه بنفسك."
  },
  "books": {
    "title": {
      "ask": "المساعد المحاسبي",
      "explain": "شرح رقم",
      "review": "مراجعة الدفاتر",
      "coding": "مقترحات سطور البنك",
      "setup": "مقترحات الإعداد"
    },
    "disclaimer": "يستخدم بيانات الدفاتر التي يحق لك الاطلاع عليها، وتُرسل إلى OpenAI بمفتاح شركتك. تحقّق من الأرقام قبل الاستناد إليها. لا يتغيّر شيء حتى تؤكّد.",
    "disclaimerStatement": "يستخدم هذا الكشف وبيانات الدفاتر التي يحق لك الاطلاع عليها، وتُرسل إلى OpenAI بمفتاح شركتك. لا تُطابَق أي سطور ولا يُرحَّل شيء حتى تؤكّد.",
    "empty": {
      "ask": "اسأل عن الدفاتر: لماذا تغيّر الربح، ومن يدين لنا بالأكثر، وماذا يُظهر تقرير ما. اطلب جدولًا متى أردت.",
      "explain": "اختر ✦ على سطر في التقرير لترى ما وراء الرقم.",
      "review": "يشرح المساعد نتائج فحص سلامة الدفاتر لهذا الشهر ويقول ما الذي يُصلح أولًا.",
      "coding": "يقترح المساعد مطابقات وتسويات للسطور غير المطابقة بعد.",
      "setup": "يقترح المساعد فئات مصروفات وحسابات ناقصة وربطًا للحسابات. يصل كل مقترح في بطاقة تؤكّدها أو ترفضها."
    },
    "suggest": {
      "profit": "لماذا الربح أقل من الشهر الماضي؟",
      "owes": "من يدين لنا بالأكثر؟",
      "trialBalance": "اعرض ميزان المراجعة لهذا الشهر في جدول",
      "unmatched": "اقترح مطابقات للسطور غير المطابقة",
      "categories": "اقترح فئات مصروفات لهذه الشركة",
      "accounts": "ما الحسابات الناقصة لدينا؟",
      "mapping": "اقترح حسابات للأدوار غير المربوطة بعد"
    },
    "thisFinding": "هذه النتيجة",
    "explain": {
      "action": "شرح {{name}}",
      "label": "ما وراء هذا الرقم",
      "loading": "جارٍ تحميل حركات الرقم…",
      "asOf": "في {{date}}",
      "total": "الإجمالي",
      "compared": "فترة المقارنة",
      "comparedWith": "مقارنةً بـ {{period}}",
      "change": "التغيّر",
      "movements": "أكبر الحركات",
      "source": "المستند",
      "amount": "المبلغ",
      "compareAmount": "المقارنة",
      "noSource": "سجل لا يمكنك فتحه",
      "other": "بقية الحركات",
      "noMovements": "لم يتحرك هذا الرقم خلال الفترة.",
      "accounts": "حسابات هذا السطر",
      "ask": "اطلب من المساعد الشرح",
      "askHint": "الأرقام أعلاه من الدفاتر دون المساعد. المساعد يضيف الشرح، ولا يتغيّر شيء حتى تؤكّد.",
      "asked": "طُرح السؤال أدناه. الأرقام أعلاه من الدفاتر دون المساعد.",
      "types": {
        "sales_invoice": "فاتورة مبيعات",
        "receipt": "سند قبض",
        "credit_note": "إشعار دائن",
        "customer_refund": "مبلغ مسترد لعميل",
        "purchase": "فاتورة شراء",
        "supplier_payment": "دفعة لمورد",
        "supplier_return": "مرتجع مورد",
        "supplier_refund": "مبلغ مسترد من مورد",
        "expense": "مصروف",
        "treasury_transfer": "تحويل نقدي أو بنكي",
        "treasury_account": "رصيد افتتاحي لحساب نقدي أو بنكي",
        "bank_statement": "التسوية البنكية",
        "stock_adjustment": "تسوية مخزون",
        "stock_transfer": "تحويل مخزون",
        "pos_sale": "بيع من نقطة البيع",
        "pos_return": "مرتجع في نقطة البيع",
        "pos_shift": "وردية صندوق (زيادة أو عجز نقدي)",
        "project_material_issue": "صرف مواد",
        "project_cost_entry": "تكلفة مشروع",
        "journal_entry": "قيد يومية"
      },
      "actionMovement": "شرح الحركة على {{account}}",
      "customer": "العميل"
    },
    "review": {
      "action": "راجِع مع المساعد",
      "prompt": "راجع الدفاتر من {{from}} إلى {{to}}: ما الذي أُصلحه أولًا؟"
    },
    "setup": {
      "action": "اقتراح…",
      "prompt": {
        "categories": "اقترح فئات مصروفات لهذه الشركة، مع الحساب الذي تُرحَّل إليه كل فئة.",
        "accounts": "ما الحسابات الناقصة في دليل حساباتنا بحسب طريقة عملنا؟ اقترحها.",
        "mapping": "اقترح حسابات لأدوار الحسابات غير المربوطة بعد."
      }
    },
    "coding": {
      "bankAction": "اقتراحات للسطور غير المطابقة",
      "bankPrompt": "اقترح مطابقات أو تسويات للسطور غير المطابقة في هذا الكشف."
    },
    "commentary": {
      "action": "صياغة تعليق الإدارة",
      "title": "تعليق الإدارة",
      "description": "مسودة للفترة {{period}} من الدفاتر. اقرأها وتحقّق من الأرقام قبل مشاركتها.",
      "prompt": "صُغ تعليق الإدارة للفترة {{period}}.",
      "sections": {
        "summary": "الملخص",
        "revenue": "الإيرادات",
        "costs": "التكاليف",
        "cash": "النقد",
        "watch": "نقاط للمتابعة"
      },
      "check": "الأرقام الموسومة «غير مؤكَّد» لم ترد من الدفاتر: تحقّق منها قبل مشاركة التعليق.",
      "copy": "نسخ",
      "copied": "نُسخ التعليق",
      "copyFailed": "تعذّر نسخ التعليق. حدّد النص وانسخه بنفسك.",
      "printNote": "صيغ بمساعدة المساعد الذكي؛ تحقّق من الأرقام قبل الاستناد إليها.",
      "unverifiedList": "تحقّق من هذه الأرقام، فلم يُرجعها أي تقرير من دفاترك:"
    }
  },
  "stock": {
    "menu": "المساعد الذكي",
    "title": {
      "ask": "مساعد المخزون",
      "explain": "شرح منتج",
      "review": "مراجعة المخزون",
      "reorder": "مقترحات إعادة الطلب"
    },
    "disclaimer": "يستخدم بيانات المخزون التي يحق لك الاطلاع عليها، وتُرسل إلى OpenAI بمفتاح شركتك. تحقّق من الأرقام قبل الاستناد إليها. لا يتغيّر شيء حتى تؤكّد.",
    "empty": {
      "ask": "اسأل عن المخزون: ما الذي يوشك على النفاد، وأين يوجد منتج ما، وما الذي شُطب. اطلب جدولًا متى أردت.",
      "explain": "اختر ✦ على منتج لترى ما الذي حرّك كميته وتكلفته.",
      "review": "يقرأ المساعد فحوص المخزون ويقول ما الذي يُصلح أولًا.",
      "reorder": "يقول المساعد ما يُعاد طلبه وبأي كمية ومن أي مورد، ويستطيع تجهيز مسودة فاتورة شراء أو مسودة تحويل لتؤكّدها."
    },
    "suggest": {
      "runningOut": "ما الذي يوشك على النفاد؟",
      "where": "أي مستودع فيه أكبر مخزون؟",
      "writeOffs": "ما الذي شطبناه هذا الشهر؟",
      "whyQuantity": "لماذا الكمية على ما هي عليه؟",
      "whyCost": "ما الذي غيّر متوسط تكلفته؟",
      "whenOut": "متى ينفد؟",
      "fixFirst": "ما الذي أُصلحه أولًا؟",
      "belowZero": "ما المنتجات التي دون الصفر، ولماذا؟",
      "slow": "ما المخزون الراكد الذي لا يُباع؟",
      "orderWeek": "ما الذي أطلبه هذا الأسبوع؟",
      "bySupplier": "اعرض قائمة إعادة الطلب حسب المورد",
      "transfer": "ما الذي يمكن أن يرسله مستودع آخر بدلًا من الشراء؟"
    },
    "review": {
      "action": "راجِع المخزون",
      "prompt": "راجع المخزون: ما الذي أُصلحه أولًا؟",
      "promptIn": "راجع المخزون في {{warehouse}}: ما الذي أُصلحه أولًا؟"
    },
    "reorder": {
      "action": "اقترح إعادة الطلب",
      "prompt": "ما الذي أعيد طلبه، وبأي كمية، ومن أي مورد؟",
      "promptIn": "ما الذي أعيد طلبه للمستودع {{warehouse}}، وبأي كمية، ومن أي مورد؟"
    },
    "insight": {
      "action": "مؤشرات المخزون: {{name}}",
      "title": "مؤشرات المخزون"
    },
    "explain": {
      "action": "شرح {{name}}",
      "label": "ما وراء هذا المنتج",
      "loading": "جارٍ تحميل أرقام المنتج…",
      "allWarehouses": "كل المستودعات",
      "asOf": "في {{date}}",
      "status": {
        "OK": "متوفر",
        "LOW": "منخفض",
        "OUT": "نفد المخزون",
        "NEGATIVE": "دون الصفر",
        "RUNNING_OUT": "يوشك على النفاد"
      },
      "onHand": "المتوفر",
      "onOrder": "قيد الطلب",
      "reorderLevel": "حد إعادة الطلب",
      "noReorderLevel": "غير محدد",
      "usagePerDay": "الاستهلاك اليومي",
      "daysOfCover": "يكفي المخزون",
      "days_zero": "0 يوم",
      "days_one": "يومًا واحدًا",
      "days_two": "يومين",
      "days_few": "{{n}} أيام",
      "days_many": "{{n}} يومًا",
      "days_other": "{{n}} يوم",
      "lessThanDay": "أقل من يوم",
      "noCover": "لا استهلاك حديث",
      "averageCost": "متوسط التكلفة",
      "value": "القيمة بالتكلفة",
      "showDetails": "عرض التفاصيل",
      "hideDetails": "إخفاء التفاصيل",
      "byWarehouse": "حسب المستودع",
      "allOfWarehouses": "عرض كل المستودعات ({{n}})",
      "fewerWarehouses": "عرض أقل",
      "reason": "السبب",
      "count": "عدد الحركات",
      "in": "وارد",
      "out": "صادر",
      "lastReceived": "آخر استلام",
      "lastIssued": "آخر صرف",
      "lastBought": "آخر شراء",
      "lastCost": "تكلفة الوحدة حينها",
      "suggestion": "ما تقترحه قاعدة إعادة الطلب",
      "suggestedLevel": "حد إعادة الطلب",
      "suggestedOrder": "الكمية المطلوبة الآن",
      "nothingToOrder": "لا حاجة إلى الطلب الآن",
      "setLevel": "تحديد حد إعادة الطلب عند {{level}}",
      "setLevelConfirm": "تحديد حد إعادة الطلب عند {{level}}؟ الحد الآن {{current}}.",
      "setLevelConfirmUnset": "تحديد حد إعادة الطلب عند {{level}}؟ لا حد محدد الآن.",
      "setLevelDo": "تحديد الحد",
      "setLevelDone": "حُدّد حد إعادة الطلب عند {{level}}",
      "ask": "اطلب من المساعد الشرح",
      "askHint": "الأرقام أعلاه من سجلات المخزون دون المساعد. المساعد يضيف الشرح، ولا يتغيّر شيء حتى تؤكّد.",
      "asked": "طُرح السؤال أدناه. الأرقام أعلاه من سجلات المخزون دون المساعد.",
      "blocked": {
        "paused": "أكّد المقترحات المنتظرة أدناه أو ارفضها أولًا.",
        "none_left": "لم يبقَ لك أي سؤال اليوم."
      },
      "usageNote_zero": "استُهلك {{quantity}} في آخر 0 يوم ({{to}}).",
      "usageNote_one": "استُهلك {{quantity}} في آخر يوم ({{to}}).",
      "usageNote_two": "استُهلك {{quantity}} في آخر يومين ({{from}} – {{to}}).",
      "usageNote_few": "استُهلك {{quantity}} في آخر {{n}} أيام ({{from}} – {{to}}).",
      "usageNote_many": "استُهلك {{quantity}} في آخر {{n}} يومًا ({{from}} – {{to}}).",
      "usageNote_other": "استُهلك {{quantity}} في آخر {{n}} يوم ({{from}} – {{to}}).",
      "movements_zero": "الحركات في آخر 0 يوم",
      "movements_one": "الحركات في آخر يوم واحد",
      "movements_two": "الحركات في آخر يومين",
      "movements_few": "الحركات في آخر {{n}} أيام",
      "movements_many": "الحركات في آخر {{n}} يومًا",
      "movements_other": "الحركات في آخر {{n}} يوم",
      "noMovements_zero": "لم يتحرك هذا المنتج في آخر 0 يوم.",
      "noMovements_one": "لم يتحرك هذا المنتج في آخر يوم واحد.",
      "noMovements_two": "لم يتحرك هذا المنتج في آخر يومين.",
      "noMovements_few": "لم يتحرك هذا المنتج في آخر {{n}} أيام.",
      "noMovements_many": "لم يتحرك هذا المنتج في آخر {{n}} يومًا.",
      "noMovements_other": "لم يتحرك هذا المنتج في آخر {{n}} يوم.",
      "levelNote_zero": "يغطي الحد استهلاك 0 يوم.",
      "levelNote_one": "يغطي الحد استهلاك يوم واحد.",
      "levelNote_two": "يغطي الحد استهلاك يومين.",
      "levelNote_few": "يغطي الحد استهلاك {{n}} أيام.",
      "levelNote_many": "يغطي الحد استهلاك {{n}} يومًا.",
      "levelNote_other": "يغطي الحد استهلاك {{n}} يوم.",
      "orderNote_zero": "يرفع الطلب المتوفر وما هو قيد الطلب إلى حد إعادة الطلب مضافًا إليه استهلاك 0 يوم.",
      "orderNote_one": "يرفع الطلب المتوفر وما هو قيد الطلب إلى حد إعادة الطلب مضافًا إليه استهلاك يوم واحد.",
      "orderNote_two": "يرفع الطلب المتوفر وما هو قيد الطلب إلى حد إعادة الطلب مضافًا إليه استهلاك يومين.",
      "orderNote_few": "يرفع الطلب المتوفر وما هو قيد الطلب إلى حد إعادة الطلب مضافًا إليه استهلاك {{n}} أيام.",
      "orderNote_many": "يرفع الطلب المتوفر وما هو قيد الطلب إلى حد إعادة الطلب مضافًا إليه استهلاك {{n}} يومًا.",
      "orderNote_other": "يرفع الطلب المتوفر وما هو قيد الطلب إلى حد إعادة الطلب مضافًا إليه استهلاك {{n}} يوم.",
      "noSuggestion_zero": "لا شيء: لم يُبع هذا المنتج ولم يُصرف في آخر 0 يوم.",
      "noSuggestion_one": "لا شيء: لم يُبع هذا المنتج ولم يُصرف في آخر يوم واحد.",
      "noSuggestion_two": "لا شيء: لم يُبع هذا المنتج ولم يُصرف في آخر يومين.",
      "noSuggestion_few": "لا شيء: لم يُبع هذا المنتج ولم يُصرف في آخر {{n}} أيام.",
      "noSuggestion_many": "لا شيء: لم يُبع هذا المنتج ولم يُصرف في آخر {{n}} يومًا.",
      "noSuggestion_other": "لا شيء: لم يُبع هذا المنتج ولم يُصرف في آخر {{n}} يوم."
    },
    "asksAtOnce": "يسأل المساعد فور الفتح"
  },
  "service": {
    "menu": "المساعد الذكي",
    "title": {
      "ask": "مساعد الخدمة"
    },
    "subject": "مواقع الخدمة",
    "disclaimer": "يستخدم المواقع والأماكن والمعدات التي يحق لك الاطلاع عليها، دون أسماء الشاغلين أو العناوين أو الهواتف، وتُرسل إلى OpenAI بمفتاح شركتك. لا يُضاف شيء حتى تؤكّد.",
    "empty": {
      "ask": "اسأل عن المواقع، أو قل ما تريد تجهيزه: طوابق وشقق تُضاف، أو فيلا تُنسخ، أو معدات لكل غرفة. يأتي كل تغيير في بطاقة تؤكّدها."
    },
    "suggest": {
      "floors": "أضف الطوابق من 1 إلى 10، في كل طابق الشقق من 01 إلى 04",
      "copy": "الفيلا 1 جاهزة: اجعل الفلل من 2 إلى 10 مثلها",
      "outOfOrder": "ما المعدات المعطّلة؟"
    },
    "fill": "تعبئة من قائمة أو مستند…",
    "fillHint": "يقرأ قائمة معدات إلى معاينة الاستيراد"
  },
  "company": {
    "button": "المساعد",
    "buttonHint": "اسأل المساعد عن هذه الصفحة أو عن أي شيء في الشركة",
    "conversations": "محادثاتك الأخرى",
    "noConversations": "لا محادثات أخرى بعد.",
    "title": "المساعد",
    "disclaimer": "يستخدم السجلات التي يحق لك الاطلاع عليها (المبيعات والمشتريات والعملاء والموردين والمصروفات والمنتجات والمخزون والدفاتر ومواقع الخدمة) والصفحة التي تسأل فيها، وتُرسل إلى OpenAI بمفتاح شركتك. لا يتغيّر شيء حتى تؤكّد.",
    "empty": "اسأل عمّا في هذه الصفحة، أو ابحث في الفواتير والعملاء والمشتريات والمخزون والدفاتر، أو اطلب فتح صفحة. يأتي كل تغيير في بطاقة تؤكّدها.",
    "suggest": {
      "page": "ما الذي ينبغي أن أعرفه عن هذه الصفحة؟",
      "runningOut": "ما الذي يوشك على النفاد؟",
      "owes": "من أكثر من يدين لنا؟"
    }
  }
}
